// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"272":"maintenance","578":"legal-notices","757":"not-found"}[chunkId] + "." + {"272":"73f26bb1","578":"91f0cf1d","757":"73f26bb1"}[chunkId] + ".css";
};